/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__Answer_1Inputs */

const en_help_center__getting_started__answer_1 = /** @type {(inputs: Help_Center__Getting_Started__Answer_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click the "Log in" button in the top right corner, then click "Sign up". You'll need to provide your email address, create a password, and verify your email. Once verified, you can browse battles and purchase bid packages to start participating. Account creation is free and takes less than 2 minutes.`)
};

/**
* | output |
* | --- |
* | "Click the \"Log in\" button in the top right corner, then click \"Sign up\". You'll need to provide your email address, create a password, and verify your email...." |
*
* @param {Help_Center__Getting_Started__Answer_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__answer_1 = /** @type {((inputs?: Help_Center__Getting_Started__Answer_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__Answer_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__getting_started__answer_1(inputs)
});